<template>
  <div class="question-content">
    <v-container fluid grid-list-md>
      <wes-q-text v-bind:metadata="question"></wes-q-text>

      <v-layout row wrap>
        <v-flex xs3>
          <!-- <p class="header">R&D Performers</p> -->
        </v-flex>
        <v-flex xs1>
          <p class="column-header">Basic Research</p>
        </v-flex>
        <v-flex xs1>
          <p class="column-header">Applied Research</p>
        </v-flex>
        <v-flex xs1>
          <p class="column-header">Experimental Development</p>
        </v-flex>
        <v-flex xs1>
          <p class="column-header">R&D Plant</p>
        </v-flex>
        <v-flex xs1>
          <p class="column-header">Total R&D</p>
        </v-flex>
        <v-flex xs3>
          <p class="column-header">Totals from corresponding questions R&D</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
				<v-flex xs3>
						<p class="row-label">a. Federal intramural</p>
				</v-flex>
				<v-flex xs1>
						<v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
				</v-flex>
				<v-flex xs1>
						<v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
				</v-flex>
				<v-flex xs1>
						<v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
				</v-flex>
				<v-flex xs1>
						<v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
				</v-flex>
				<v-flex xs1>
						<v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
				</v-flex>
				<v-flex xs3>
				</v-flex>
			</v-layout>
			<!-- <v-layout row wrap>
				<v-flex xs3>
						<p>Include (1) your agency’s funding of R&D conducted by your federal agency or other federal agencies, and (2) your agency’s costs for monitoring both intramural R&D and extramural R&D contracts and cooperative agreements.</p>
				</v-flex>
      </v-layout>-->
      <!-- <wes-matrix-answer
        v-bind:question-data="currentQuestion.items[0]"
        @columnValueUpdated="onColumnValueUpdated"
      ></wes-matrix-answer> -->
      <v-layout row wrap>
        <v-flex xs3>
          <p class="row-label">b. Federally Funded R&D Centers (FFRDCs)</p>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6>
          <p style="margin-left:20px;">FFRDCs are designated by the federal government, must be separately organized units receiving at least 70 percent of their funds from the federal government, and have an annual budget of at least $500,000. The FFRDCs are listed in question 16.</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs3>
          <p class="row-label">c. Businesses</p>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
        </v-flex>
        <v-flex xs3></v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6>
          <p style="margin-left:20px;">Domestic for-profit businesses or industrial firms. Exclude FFRDCs administered by these organizations.</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs3>
          <p class="row-label">d. Higher education institutions</p>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6>
          <p style="margin-left:20px;">Domestic higher education institutions and consortia. Exclude FFRDCs administered by these organizations. Consortia that include both higher education institutions and nonprofits have been assigned to one of the two categories by NSF. If your agency funds such consortia, it may be helpful to answer question 17 first so you know how they are classified.</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs3>
          <p class="row-label">e. Other nonprofits</p>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6>
          <p style="margin-left:20px;">Domestic nonprofit organizations other than universities and colleges. Include nonprofit hospitals and consortia. Exclude FFRDCs administered by nonprofit organizations.</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs3>
          <p class="row-label">f. State and local government</p>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
        </v-flex>
        <v-flex xs3></v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6>
          <p style="margin-left:20px;">State, county, municipality, or other local government entity in the United States. Do not include state and local universities and colleges or agricultural experiment stations. Report these under higher education institutions.</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs3>
          <p class="row-label">g. Non-U.S. performers</p>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6>
          <p style="margin-left:20px;">R&D performers outside of the United States. Do not include R&D performed by U.S. organizations or U.S. citizens in other nations.</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs3>
          <p class="row-label">h. Total, extramural performers (rows c-g)</p>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs3>
          <p class="row-label">i. Total, all performers</p>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline readonly></v-text-field>
        </v-flex>
        <v-flex xs3></v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs3>
          <p
            style="font-style:italic;"
          >Include (1) your agency’s funding of R&D conducted by your federal agency or other federal agencies, and (2) your agency’s costs for monitoring both intramural R&D and extramural R&D contracts and cooperative agreements.</p>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-text-field v-model="q2b2" prefix="$" suffix="" height="32" outline></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <p>Please use the space below to add explainations for data reported in this question.</p>
          <v-textarea outline name="taQ1" value></v-textarea>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs1><v-icon class="help-ico" v-on:click="onHandleHelpClicked(true)">fa fa-question-circle</v-icon></v-flex>
        <v-flex xs1></v-flex>
        <v-flex xs10>
          <div class="clearfix buttons-container">
            <v-btn class="button" rounded color="primary" dark v-on:click="onSaveClicked">Save</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <help-panel v-if="bDisplayHelp===true" v-on:closepanel="onClosePanel" v-bind:question="question.surveyQuestionInfo"></help-panel>
    <err-panel v-if="bDisplayErrors===true" v-on:closepanel="onClosePanel" v-bind:errors="errorList" v-on:closeerrorpanel="onErrorPanelCleared"></err-panel>
  </div>
</template>

<script>
import { answerService } from '../../services/answerService';
import { utilityService } from '../../services/utilityService';
import { errorService } from '../../services/errorService';
export default {
  // extends: [questionBase],
  name: "Question8",
  props: {
    question: Object,
    qId: String
  },
  data: () => ({
    q2a1: 0,
    q2a2: 0,
    q2a3: 0,
    q2b1: 0,
    q2b2: 0,
    q2b3: 0,
    isHelpDisplayed: false,
    isErrorsOverlayDisplayed: false
  }),
  computed: {
    answerOneA: function () {
      let a1 = this.$store.state["1"].a1;
      return a1 || 0;
    },
    answerOneB: function () {
      let b1 = this.$store.state["1"].b1;
      return b1 || 0;
    },
    currentQuestion: function () {
      return this.$props.question.answers;
    },
    bDisplayHelp: function () {
			return this.isHelpDisplayed;
		},
		bDisplayErrors: function () {
			return this.isErrorsOverlayDisplayed;
		}
  },
  methods: {
    onColumnValueUpdated: function (val, col) {
      console.log("Column value updated!!!");
    },
    onSaveClicked: function () {
      console.log('Called save with: ' + this.currentAnswer);
      answerService.saveSurveyQuestionAnswer(0, this.$props.question.id, this.currentAnswer);
    },
    onClosePanel: function () {
    	this.isErrorsOverlayDisplayed = false;
    	this.isHelpDisplayed = false;
    },
    onErrorPanelCleared: function () {
      this.isErrorsOverlayDisplayed = false;
    },
    onHandleHelpClicked: function (bDisplay) {
      this.isHelpDisplayed = bDisplay;
    }
  }
};
</script>

<style scoped>
.column-header {
  font-weight: bold;
  text-align: center;
}
.row-header {
  line-height: 46px;
  margin: 0;
  font-weight: bold;
  font-size: 24px;
}
.question-content {
  text-align: left;
  /* background-color: #598dc233; */
  /* border: 2px solid #13314f; */
  /* border-radius: 5px; */
  /* position: relative; */
  color: black;
}
.question-content > h1 {
  margin: 5px 0;
}
.question-content > p,
.question-content > ul {
  margin: 5px 10px;
}
.value-list {
  list-style: lower-latin;
}
.row-label {
  line-height: 60px;
  font-weight: bold;
}
.buttons-container > .button {
  float: right;
}
.v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: purple;
}
.v-input--is-focused > .v-input__control > .v-input__slot {
  border: 2px solid red;
}
.help-ico {
  font-size: 40px;
  line-height: 44px;
  color: #0000ffa3;
}
</style>
